import { render, staticRenderFns } from "./DetailsImage.vue?vue&type=template&id=8d008204"
import script from "./DetailsImage.vue?vue&type=script&lang=ts"
export * from "./DetailsImage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d008204')) {
      api.createRecord('8d008204', component.options)
    } else {
      api.reload('8d008204', component.options)
    }
    module.hot.accept("./DetailsImage.vue?vue&type=template&id=8d008204", function () {
      api.rerender('8d008204', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/DetailsImage.vue"
export default component.exports